<script setup>
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const PUGONGYING_URL = 'https://uao-online.com';

const openLink = () => {
  window.open(PUGONGYING_URL, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <div class="overflow-auto p-6 w-full h-full flex items-center">
    <div
      class="w-full flex flex-col lg:flex-row gap-8 items-center max-w-6xl mx-auto"
    >
      <!-- Left: Text content -->
      <div class="flex-1 space-y-5 min-w-0">
        <div class="flex items-center gap-3 mb-1">
          <img
            :src="'/dashboard/images/integrations/pugongying.png'"
            class="h-12 w-12 rounded-lg border border-n-weak shadow-sm block dark:hidden bg-n-alpha-3"
          />
          <img
            :src="'/dashboard/images/integrations/pugongying-dark.png'"
            class="h-12 w-12 rounded-lg border border-n-weak shadow-sm hidden dark:block bg-n-alpha-3"
          />
          <h2 class="text-2xl font-bold text-n-slate-12">
            {{ t('INTEGRATION_SETTINGS.PUGONGYING.TITLE') }}
          </h2>
        </div>
        <p class="text-n-slate-11 text-sm leading-7">
          {{ t('INTEGRATION_SETTINGS.PUGONGYING.DESCRIPTION') }}
        </p>
        <div>
          <Button
            blue
            icon="i-lucide-external-link"
            :label="$t('INTEGRATION_SETTINGS.PUGONGYING.VISIT')"
            @click="openLink"
          />
        </div>
      </div>

      <!-- Right: Hero image -->
      <div class="flex-1 min-w-0">
        <img
          :src="'/dashboard/images/integrations/pugongying-hero.png'"
          class="w-full rounded-lg shadow-lg border border-n-weak"
          alt="智域蒲公英AI+"
        />
      </div>
    </div>
  </div>
</template>
